export default {
  /**
   *
   * @param Vue
   * @param options
   */
  install(Vue, options) {
    /**
     *
     * @param str
     * @returns {*}
     */
    Vue.prototype.$getNumber = function (str) {
      return parseInt(str.replace(/\D+/g, ""))
    }

    /**
     *
     * @param search
     * @param str
     * @returns {boolean}
     */
    Vue.prototype.$searchString = function (search, str) {
      return str.toLowerCase().indexOf(search.toLowerCase()) > -1
    }

  }
}
